module.exports = __webpack_public_path__ + "img/Loader.5d87c778.svg";